import { render } from "./form.vue?vue&type=template&id=5179ac97"
import script from "./formComponent.js?vue&type=script&lang=js"
export * from "./formComponent.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__